//ANT Design
import { message } from 'antd';

// Axios
import { instance } from './axios.instance';

import { formatResContent, textToRaw, triggersToRaw } from '../utils/dataSync';
import axios from 'axios';
import { dockerEditorUrl, handleLocalPdfResponse } from '../utils/localPdf';

export const getTemplates = async () => {
  try {
    const res = await instance.get('/proposals/templates/');
    if (res.status === 200) {
      return res.data;
    }
    throw new Error(`GET proposal templates status code ${res.status}`);
  } catch (error) {}
};

// Suppression définitive d'un template jetable (cf. shapeScratchApp.jsx) — le
// serveur ne l'exécute que si le template porte bien `scratch: true`, jamais
// sur un template réel.
export const deleteScratchTemplate = async (id) => {
  try {
    await instance.delete(`/proposals/templates/${id}/destroy_scratch`);
  } catch (error) {}
};

export const getHiddenTemplates = async () => {
  try {
    const res = await instance.get('/proposals/templates/hidden');
    if (res.status === 200) {
      return res.data;
    }
    throw new Error(`GET hidden proposal templates status code ${res.status}`);
  } catch (error) {}
};

export const restoreTemplate = async (id) => {
  try {
    const res = await instance.post(`/proposals/templates/${id}/restore`);
    if (res.status === 200) {
      message.success("L'élément a été restauré avec succès.");
      return res.data;
    }
    throw new Error(`POST restore template ${id} status code ${res.status}`);
  } catch (error) {
    message.error("L'élément n'a pas pu être restauré.");
    return false;
  }
};

export const getOpportunityTemplates = async (id) => {
  try {
    const res = await instance.get(`/proposals/opportunities/${id}/templates/`);
    if (res.status === 200) {
      return res.data;
    }
    throw new Error(`GET proposal templates status code ${res.status}`);
  } catch (error) {}
};

export const getOfferTemplates = async (id) => {
  try {
    const res = await instance.get(`/proposals/offers/${id}/templates/`);
    if (res.status === 200) {
      return res.data;
    }
    throw new Error(`GET proposal templates status code ${res.status}`);
  } catch (error) {}
};

export const deleteTemplate = async (id) => {
  try {
    const res = await instance.delete(`/proposals/templates/${id}`);
    if (res.status === 204) {
      message.success('Le modèle a bien été supprimé.');
      return true;
    }
    throw new Error(`DELETE proposal template ${id} status code ${res.status}`);
  } catch (error) {
    message.error("Le modèle n'a pas pu être supprimé.");
    return false;
  }
};

export const postTemplate = async ({
  name,
  templatable,
  pattern,
  landscape,
  boxes,
  pages,
  masks,
  configuration,
  summaryConfiguration,
  work,
  documentTypeIds,
  variables,
  variableGroups,
  variableOrderArray,
  triggers,
  isRecursive = false,
  recursiveModelName = null,
  recursiveAgreementType = null,
  folderId = null,
  scratch = undefined,
  adminOnly,
}) => {
  if (!boxes) return;
  try {
    const res = await instance.post('/proposals/templates/', {
      name: name,
      document_type_ids: documentTypeIds,
      templatable,
      pattern,
      landscape,
      work,
      folder_id: folderId,
      admin_only: adminOnly,
      ...(scratch !== undefined ? { scratch } : {}),
      content: {
        boxes: textToRaw(boxes),
        pages,
        configuration,
        summaryConfiguration,
        variables,
        variableGroups,
        variableOrderArray,
        triggers: triggersToRaw(triggers, boxes),
        masks: masks.map((m) => {
          return {
            ...m,
            boxes: m.boxes ? textToRaw(m.boxes) : [],
          };
        }),
        isRecursive,
        recursiveModelName,
        recursiveAgreementType,
      },
    });
    if (res.status === 200) {
      return res.data;
    }

    throw new Error(`POST proposal template  status code ${res.status}`);
  } catch (error) {
    throw error;
  }
};

export const updateTemplate = async ({
  id,
  name,
  pattern,
  landscape,
  templatable,
  boxes,
  masks,
  configuration,
  summaryConfiguration,
  gridConfiguration,
  work,
  containers,
  columns,
  rowContainers,
  document_type_ids,
  variables,
  variableGroups,
  variableOrderArray,
  triggers,
  isRecursive = false,
  recursiveModelName = null,
  recursiveAgreementType = null,
}) => {
  if (!containers || !columns) return;
  try {
    const res = await instance.patch(`/proposals/templates/${id}`, {
      name: name,
      templatable,
      landscape,
      pattern,
      work,
      document_type_ids: document_type_ids,
      content: {
        variables,
        variableGroups,
        variableOrderArray,
        triggers: triggersToRaw(triggers, boxes),
        boxes: textToRaw(boxes.filter((b) => b?.from_linked_section !== true)),
        containers: containers.filter((c) => c?.from_linked_section !== true),
        columns: columns.filter((c) => c?.from_linked_section !== true),
        rowContainers: (rowContainers ?? []).filter(
          (c) => c?.from_linked_section !== true
        ),
        configuration: (({ zoom, ...restConfiguration }) => restConfiguration)(
          configuration
        ),
        summaryConfiguration,
        gridConfiguration,
        masks: masks.map((m) => {
          return {
            ...m,
            boxes: m.boxes ? textToRaw(m.boxes) : [],
          };
        }),
        isRecursive,
        recursiveModelName,
        recursiveAgreementType,
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    throw new Error(`PATCH proposal template ${id} status code ${res.status}`);
  } catch (error) {
    throw error;
  }
};

export const getTemplate = async (
  id,
  defaultVariablesApi,
  currentDocIsTemplate = false
) => {
  try {
    const res = await instance.get(`/proposals/templates/${id}`);
    if (res.status === 200) {
      // return res.data;
      res.data.content = formatResContent(
        res.data.content,
        defaultVariablesApi,
        currentDocIsTemplate,
        res.data.landscape
      );
      return res.data;
    }
    throw new Error(`GET proposal template ${id} status code ${res.status}`);
  } catch (error) {
    return {
      error,
    };
  }
};
export const updateTemplateInfos = async (id, { name, document_type_ids, admin_only }) => {
  try {
    const res = await instance.post(`/proposals/templates/${id}/update_infos`, {
      name,
      document_type_ids,
      admin_only,
    });
    if (res.status === 200) {
      message.success(`Le modèle ${res.name} a bien été modifé.`);
      return res.data;
    }
    throw new Error(`MODIFY proposal ${id} status code ${res.status}`);
  } catch (error) {
    message.success("Le modèle n'a pas pu être modifié.");
    return false;
  }
};

export const duplicateTemplate = async (id, newName) => {
  try {
    const res = await instance.post(`/proposals/templates/${id}/duplicate`, {
      name: newName,
    });
    if (res.status === 200) {
      message.success(`Le modèle a bien été dupliqué.`);
      return res.data;
    }
    throw new Error(`DUPLICATE template ${id} status code ${res.status}`);
  } catch (error) {
    message.error("Le modèle n'a pas pu être dupliqué.");
    return false;
  }
};

export const fetchPdf = async ({
  currentDocument,
  boxes,
  masks,
  configuration,
  summaryConfiguration,
  gridConfiguration,
  name,
  containers,
  columns,
  rowContainers,
  landscape,
  type,
  variables,
  variableGroups,
  variableOrderArray,
  triggers,
  currentTemplate,
  tmp,
}) => {
  if (!containers || !columns || !currentDocument.id) return;
  try {
    const commonPayload = {
      content: {
        boxes: textToRaw(boxes),
        configuration: (({ zoom, ...restConfiguration }) => restConfiguration)(
          configuration
        ),
        containers,
        columns,
        rowContainers: rowContainers ?? [],
        summaryConfiguration,
        gridConfiguration,
        variables,
        variableGroups,
        variableOrderArray,
        triggers: triggersToRaw(triggers, boxes),
        masks: masks.map((m) => {
          return {
            ...m,
            boxes: m.boxes ? textToRaw(m.boxes) : [],
          };
        }),
        tmp,
      },
      landscape,
      name,
      must_be_saved: type === 'archive',
      is_for_preview: type === 'preview',
    };
    // In case you want to test with local pdf generator, fill this variable
    // with the Lambda RIE invocation endpoint in your .env
    // (http://localhost:9000/2015-03-31/functions/function/invocations).
    if (process.env.REACT_APP_LOCAL_PDF_URL) {
      const result = await axios
        .post(process.env.REACT_APP_LOCAL_PDF_URL, {
          ...commonPayload,
          editor_url: dockerEditorUrl(),
          is_template: true,
        })
        .then((response) => handleLocalPdfResponse(response, type, name));
      return { ok: true, result };
    }
    const url = `/proposal/templates/${currentDocument.id}/generate_pdf`;

    const res = await instance.post(url, commonPayload);
    if (res.status === 202) {
      return res.data;
    } else {
      throw new Error(`POST proposal template status code ${res.status}`);
    }
  } catch (error) {
    throw error;
  }
};

// Injection d'un document Costing : le fichier est déjà stocké côté serveur, il
// n'y a donc ni URL présignée ni upload. Le backend en fait une copie
// temporaire et lance la même conversion PDF -> images que l'import manuel, qui
// répond par le même canal websocket.
export const postCostingDocumentPdf = async ({
  id,
  boxId,
  documentId,
  setLoaderPdfToImage,
  currentDocumentType,
}) => {
  setLoaderPdfToImage(true);

  try {
    const urlBase =
      currentDocumentType === 'template' ? '/proposal/templates' : '/proposal';
    const res = await instance.post(
      `${urlBase}/${id}/documents/${documentId}/pdf`,
      { box_id: boxId }
    );

    if (res.status === 200) {
      message.success('Le PDF a bien été enregistré');
      setTimeout(() => {
        message.loading('Traitement du PDF en cours...', 0);
      }, 500);
      return res.data;
    }

    throw new Error(`POST costing document pdf status code ${res.status}`);
  } catch (error) {
    setLoaderPdfToImage(false);
    message.destroy();
    // Le backend distingue le document hors périmètre du fichier manquant sur
    // le stockage : son message est plus utile que le nôtre quand il existe.
    const serverMessage = error.response?.data?.error;
    if (error.response?.status === 404) {
      message.error(serverMessage ?? "Ce document n'est plus disponible");
    } else {
      message.error("Une erreur est survenue lors de l'injection du document");
    }
    return {};
  }
};

export const postPdfInTemplate = async ({
  id,
  boxId,
  file,
  setLoaderPdfToImage,
  currentDocumentType,
}) => {
  console.log('postPdfInTemplate', id, boxId, file, currentDocumentType);

  // Activer le loader dès le début
  setLoaderPdfToImage(true);

  try {
    let urlBase = '';
    if (currentDocumentType === 'template') {
      urlBase = '/proposal/templates';
    } else {
      urlBase = '/proposal';
    }

    // Obtenir une URL presignée S3 et uploader directement
    const presignedUrlRes = await instance.post(
      `${urlBase}/${id}/pdf/presigned_url`,
      {
        filename: file.name,
        box_id: boxId,
      }
    );

    if (
      presignedUrlRes.status !== 200 ||
      !presignedUrlRes.data?.presigned_url
    ) {
      throw new Error("Impossible d'obtenir l'URL presignée S3");
    }

    const { presigned_url, s3_key } = presignedUrlRes.data;

    // Upload direct vers S3 avec fetch
    // Ne pas envoyer de headers pour éviter la requête preflight CORS
    // L'URL presignée contient déjà les headers signés nécessaires
    let uploadResponse;
    try {
      uploadResponse = await fetch(presigned_url, {
        method: 'PUT',
        body: file,
        // Ne pas mettre de headers pour éviter la preflight OPTIONS
      });

      if (!uploadResponse.ok) {
        const errorText = await uploadResponse.text();
        throw new Error(
          `Erreur lors de l'upload vers S3: ${uploadResponse.status} ${uploadResponse.statusText} - ${errorText}`
        );
      }
    } catch (error) {
      throw error;
    }

    // Envoyer la clé S3 au backend
    const res = await instance.post(`${urlBase}/${id}/pdf`, {
      s3_key: s3_key,
      box_id: boxId,
      filename: file.name,
    });

    if (res.status === 200) {
      // Afficher d'abord le message de succès
      message.success('Le PDF a bien été enregistré');

      // Ensuite afficher la notification de traitement en cours (avec un petit délai pour que le message de succès soit visible)
      setTimeout(() => {
        message.loading('Traitement du PDF en cours...', 0);
      }, 500);

      return res.data;
    }

    throw new Error(`POST proposal template status code ${res.status}`);
  } catch (error) {
    // Désactiver le loader en cas d'erreur
    setLoaderPdfToImage(false);
    // Fermer toutes les notifications en cas d'erreur
    message.destroy();
    if (error.response?.status === 404) {
      message.error(
        "L'endpoint presigned_url n'est pas disponible. Contactez l'administrateur."
      );
    } else {
      message.error('Une erreur est survenue lors de la sauvegarde du PDF');
    }
    return {};
  }
};
